export default __webpack_public_path__ + "static/report-image-one-c261a14693e4f8dc1df653e0371727f7.png";